import './App.css';
import './index.css';
import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from "framer-motion";
import Home from './pages/home';
import Contact from './pages/contact';
import About from "./pages/about"
import Condition from "./pages/condition";
import Confidentiality from "./pages/confidentiality";
import NotFound from "./pages/notFound";
import InfoService from "./pages/infoService";
import Projet from "./pages/projet";

function SmoothAnchorScroll() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onClick = (event) => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor) return;

      const href = anchor.getAttribute("href");
      if (!href || href === "#") return;

      const target = document.querySelector(href);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      if (location.pathname !== "/") {
        event.preventDefault();
        navigate(`/${href}`);
      }
    };

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [navigate, location.pathname]);

  return null;
}

function InternalNavigationHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const onClick = (event) => {
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const anchor = event.target.closest("a[href]");
      if (!anchor) return;

      const href = anchor.getAttribute("href");
      if (!href) return;
      if (href.startsWith("#")) return;
      if (href.startsWith("http://") || href.startsWith("https://")) return;
      if (href.startsWith("mailto:") || href.startsWith("tel:")) return;
      if (anchor.target === "_blank") return;
      if (anchor.hasAttribute("download")) return;

      event.preventDefault();
      navigate(href);
    };

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [navigate]);

  return null;
}

function FadePage({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

function getRouteKey(pathname) {
  if (pathname.startsWith("/infoService")) return "/infoService";
  return pathname;
}

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={getRouteKey(location.pathname)}>
        <Route path="/" element={<FadePage><Home /></FadePage>} />
        <Route path="/contact" element={<FadePage><Contact /></FadePage>} />
        <Route path="/about" element={<FadePage><About /></FadePage>} />
        <Route path="/condition" element={<FadePage><Condition /></FadePage>} />
        <Route path="/confidentiality" element={<FadePage><Confidentiality /></FadePage>} />
        <Route path="/infoService/:id" element={<FadePage><InfoService /></FadePage>} />
        <Route path="/projet" element={<FadePage><Projet /></FadePage>} />
        <Route path="*" element={<FadePage><NotFound /></FadePage>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SmoothAnchorScroll />
      <InternalNavigationHandler />
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App;
